import { AnimatePresence, motion } from "motion/react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Tooltip from "./Tooltip";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { store } from "../Store/store";
import { limpiarToken } from "../Store/slicers/tokenAuth";

export default function Sidebar({ modules, sidebarOpen, setSidebarOpen }) {

    const location = useLocation();
    const navigation = useNavigate()

    const cerrarSesion = () => {
        store.dispatch(limpiarToken());
        navigation('/login')
    }

    return (
        <motion.aside
            initial={{ x: -80, opacity: 0 }}
            animate={{ x: sidebarOpen ? 0 : -120, opacity: 1 }}
            exit={{ x: -120, opacity: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            className="h-screen d-flex flex-column justify-content-between py-4 px-2 rounded-end-4 shadow-lg"
            style={{ width: "100px", backgroundColor: "#0F172A", color: "white", height: '100vh' }}
        >

            <div className="text-end mb-2">
                <button
                    onClick={() => setSidebarOpen(false)}
                    style={{
                        border: "none",
                        background: "transparent",
                        color: "white",
                        fontSize: "20px",
                        cursor: "pointer"
                    }}
                >
                    ✕
                </button>
            </div>
            {/* Logo */}

            <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.4 }}
                className="text-white font-bold text-lg text-center"
            >
                <Link to="/home">
                    <motion.img
                        src="/img/cumbresLogoff.png"
                        alt="login visual"
                        className="w-100 object-fit-cover mt-4"
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
                    />
                </Link>
            </motion.div>

            {/* MENÚ CENTRADO */}
            <div className="flex flex-col flex-grow justify-center items-center mt-5">
                <nav className="flex flex-col items-center gap-8 text-center">

                    {modules.map((mod, i) => {
                        const isActive = location.pathname === mod.ruta_mod;
                        return (

                            <Link to={`${mod.ruta_mod}`} key={i} >
                                <motion.div
                                    whileHover={{
                                        scale: 1.2,
                                        backgroundColor: "rgba(10,37,64,0.9)"
                                    }}
                                    transition={{ type: "spring", stiffness: 300 }}
                                    className="text-white p-2 rounded-xl cursor-pointer flex items-center justify-center"
                                >
                                    {/* Círculo de fondo (solo si está activo) */}

                                    <Tooltip text={mod.boton} >
                                        <motion.img
                                            src={`${isActive ? mod.img_mod_alternativo : mod.img_mod}`}
                                            alt={mod.name}
                                            className="img-fluid object-contain"
                                            animate={{
                                                rotate: isActive ? 5 : 0,
                                            }}
                                            transition={{ type: "spring", stiffness: 200 }}
                                            style={
                                                isActive ? {
                                                    width: "40px",
                                                    height: "40px",
                                                    borderRadius: "50%",
                                                    padding: "8px",
                                                    backgroundColor: "#f5f7fa",
                                                    transition: "background-color 0.3s ease",
                                                } : ''}
                                        />
                                    </Tooltip>


                                </motion.div>
                                {/* Conexión visual si está activo */}
                            </Link>

                        );
                    })}
                </nav>
            </div>

            {/* ---------- FOOTER: CERRAR SESIÓN ---------- */}
            <div className="text-center mb-3">
                <Tooltip text="CERRAR SESIÓN" >
                    <motion.div
                        whileHover={{
                            scale: 1.1,
                            backgroundColor: "rgba(220, 53, 69, 0.9)", // rojo tipo danger
                        }}
                        transition={{ type: "spring", stiffness: 250 }}
                        className="text-white p-2 rounded-3 cursor-pointer d-flex align-items-center justify-content-center mx-auto pointer"
                        style={{
                            width: "45px",
                            height: "45px",
                            backgroundColor: "rgba(220, 53, 69, 0.7)",
                        }}
                    >
                        <ExitToAppIcon style={{ fontSize: 24 }} onClick={cerrarSesion} />
                    </motion.div>
                </Tooltip>
            </div>

        </motion.aside>
    );
}